import { useEffect } from 'react';

const addBodyClass = (className) => document.body.classList.add(className);
const removeBodyClass = (className) => document.body.classList.remove(className);

export default function useBodyClass(className) {
  useEffect(() => {
    // Set up
    addBodyClass(className);

    // Clean up
    return () => {
      removeBodyClass(className);
    };
  }, [className]);
}
